<template>
  <div class="ah-drawer" v-show="show">
    <img
      class="ah-drawer-close-button"
      :aria-label="closeLabel"
      :src="closeIconSrc"
      @click="toggle"
    />
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'drawer',
    data() {
      return {
        closeIconSrc: '../../../../../Static/icons/AH/x.svg',
        closeLabel: window.vueData.components['filter-drawer'].closeButtonAriaLabel || 'Close'
      }
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      toggle: Function,
    },
  }
</script>

<style lang="scss" scoped>
  .ah-drawer {
    position: fixed;
    top: 0;
    right: 0;
    min-width: 330px;
    height: 100%;
    padding: 52px 24px;
    overflow-y: auto;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0 0 60px 0 rgba(0,35,74,0.25);
    z-index: 9999;
  }
  .ah-drawer-close-button {
    position: absolute;
    top: 18px;
    right: 18px;
    cursor: pointer;
  }
</style>